module.exports = require("swa-bootstrap-corporate-landing-home-page/app-settings/corporate-landing-home-page-app-settings.corporate");